import { createFileRoute } from '@tanstack/react-router';
import { SubscriptionRedirectRoute } from './-route-wrappers';

// `/settings/subscription` redirects to the Your Plan tab (FPS-2286), mirroring the receipts
// redirect. Only the bare path is owned here — there is no route beneath it, so nested URLs fall
// through to the `settings/$` splat and render the embedded app.
export const Route = createFileRoute('/_authenticated/settings/subscription')({
  component: SubscriptionRedirectRoute,
});
